import React, { useEffect, useState } from 'react';
// import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';
import { Card, CardContent, makeStyles, Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
// import axios from 'axios';
import DataTable from './view/index';
import SearchBox from '../../../components/table/SearchBox';
import FormDialog from '../../../components/table/FormDialog';
// import { CommonConfig } from '../../../config/common-config';
// import AuditOpenService from '../auditopenservices';

const useStyles = makeStyles((theme) => ({
    noRecord: {
        display: 'flex',
        justifyContent: 'center',
        background: '#f6f6f6',
        margin: '16px',
        '& h1': {
            alignSelf: 'center',
            color: 'grey',
            fontFamily: 'Rubik',
            fontSize: '14px',
            fontWeight: '400',
        },
    },
}));

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function AuditOpenservices(props) {
    const classes = useStyles();
    const [searchQuery, setSearchQuery] = useState('');
    const [openBox, setOpenBox] = useState(false);
    const [deleteMsg, setDeleteMsg] = useState('');
    const [rows, setPendingInvoices] = useState([]);
    const triggerUseEffect = useSelector((state) => state.serviceCheckListReducer.triggerUseEffect);
    const vertical = 'top';
    const horizontal = 'center';
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);
    const dbname = tennantDetails.tennantName;
    const invoiceId = rows.id;

    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;


    const headCells = [
        { id: 'serviceid', label: 'Service ID' },
        { id: 'clientid', label: 'Client ID' },
        { id: 'clienttype', label: 'Client Type' },
        { id: 'servicetype', label: 'Service Type' },
        { id: 'year', label: 'Year' },
        { id: 'startDate', label: 'Start Date' },
        { id: 'scopeofaudit', label: 'Scope Of Audit' },
        { id: 'remarks', label: 'Remarks' },
        { id: 'statusId', label: 'Current status' },
    ];


    // useEffect(() => {
    //     axios
    //         .get(`${CommonConfig.dev.baseUrl}/api/auth/open-invoices/Advith`, {
    //             headers: {
    //                 Authorization: bearerToken,
    //             },
    //         })
    //         .then((response) => {
    //             setPendingInvoices(response.data.content);
    //         })
    //         .catch((error) => {});
    // }, [bearerToken, triggerUseEffect]);


    const handleSearchQuery = (searchData) => {
        //console.log(searchData);
        setSearchQuery(searchData);
    };

    const handleSave = () => { };

    const handleClose = () => {
        setOpenBox(false);
    };
    const [previousButton, setpreviousButton] = useState(true);
    const [nextButton, setnextButton] = useState(true);
    const filteredRow = searchQuery
        ? rows.filter((searchRow) => {
            const query = searchQuery.toLowerCase().trim();
            return headCells
                .map((col) => col)
                .some((key) => {
                    if (key.isConcat && searchRow[key.id]) {
                        const subdata = searchRow[key.id];
                        const mergedData = key.concatElem.map((concatdata) => {
                            return concatdata.split('.').reduce((acc, item) => {
                                if (Object.prototype.hasOwnProperty.call(acc, item)) {
                                    if (typeof acc[item] !== 'object') {
                                        return acc[item].toString().toLowerCase().includes(query);
                                    }
                                    return acc[item];
                                }

                                return false;
                            }, subdata);
                        });

                        return mergedData[0];
                    }
                    return searchRow[key.id].toString().toLowerCase().includes(query);
                });
        })
        : rows;
    return (
        <>
            <Snackbar open={openBox} anchorOrigin={{ vertical, horizontal }} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="success">
                    {deleteMsg}
                </Alert>
            </Snackbar>
            <Card className="custom-table">
                <>
                    <div>
                        <CardContent className="card-title-display">
                            <Grid item xs={12} sm={8}>
                                <Typography className="card-title">Open Services</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6} className="card-search">
                                <div className="search-field">
                                    <SearchBox searchQuery={searchQuery} onChange={handleSearchQuery} placeholder="Search..." />
                                </div>
                                {/* <div className="card-add-button">
                                </div> */}
                            </Grid>
                            <FormDialog row={[]} pageName="core" show="AddIcon" />
                        </CardContent>
                    </div>
                    <CardContent className="card-table-display">
                        {rows && filteredRow.length > 0 ? (
                            <>
                                <DataTable
                                    rows={filteredRow}
                                    headCells={headCells}
                                    saveRow={handleSave}
                                    axiosConfig={bearerToken}
                                    tennantName={dbname}
                                    id={invoiceId}
                                    pageName="core"
                                    action
                                    prvnxtbt={{ prvBt: previousButton, nxtBt: nextButton }}
                                />
                            </>
                        ) : (
                                <div className={classes.noRecord}>
                                    <h1>No records to display</h1>
                                </div>
                            )}
                    </CardContent>
                </>
            </Card>
        </>
    );
}
export default AuditOpenservices;
